<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="600" scrollable>
			<v-card>
				<v-card-title class="text-body-1 pb-1">
					<span>Detail Driver</span>
					<span class="pl-2">{{ detailDriver.driver_username }}</span>
				</v-card-title>
				<v-card-text class="black--text pb-3">
					<v-row class="mb-3">
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Nama Driver</div>
							<div class="">{{ detailDriver.driver_name }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Username</div>
							<div class="">{{ detailDriver.driver_username }}</div>
						</v-col>
						<v-col cols="6" md="4" class="pr-1">
							<div class="grey--text text--darken-2">Login Terakhir</div>
							<div class="">{{ detailDriver.driver_last_login_datetime ? formatDateText(detailDriver.driver_last_login_datetime, 'DD MMMM YYYY hh:mm:ss') : '-' }}</div>
						</v-col>
						
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">No. SIM</div>
							<div class="">{{ detailDriver.driver_passport }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Jumlah Ekspedisi</div>
							<div class="">{{ detailDriver.driver_run_count }}</div>
						</v-col>
						<v-col cols="6" md="4" class="pr-1">
							<div class="grey--text text--darken-2">Ekspedisi Terakhir</div>
							<div class="">{{ detailDriver.driver_last_run_datetime ? formatDateText(detailDriver.driver_last_run_datetime, 'DD MMMM YYYY') : '-' }}</div>
						</v-col>
						<!-- <v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Driver Rating</div>
							<div class="d-flex">
								<v-icon small color="yellow">mdi-star</v-icon>
								<div class="pl-2">{{ detailDriver.driver_rating }}</div>
							</div>
						</v-col> -->
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Status Driver</div>
							<div class="d-flex align-center">
								<template v-if="detailDriver.driver_status === 'stand_by'">
									<v-icon color="green">mdi-check-circle</v-icon>
									<span class="pl-2">{{ detailDriver.driver_status | statusDriver }}</span>
								</template>

								<template v-else>
									<v-icon color="grey lighten-2">mdi-checkbox-blank-circle</v-icon>
									<span class="pl-2">
										{{ detailDriver.driver_status | statusDriver }}
									</span>
								</template>
							</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Status Aktif</div>
							<div>
								<template v-if="detailDriver.driver_is_active == 'active'">
									<v-chip color="green" small class="px-5 white--text">Aktif</v-chip>
								</template>
								<template v-else>
									<v-chip color="red" small class="px-5 white--text">Tidak Aktif</v-chip>
								</template>
							</div>
						</v-col>
						<v-col md="12"></v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Jenis Kelamin</div>
							<div class="">{{ detailDriver.driver_gender | toGender }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Tempat / Tanggal Lahir</div>
							<div class="">{{ detailDriver.driver_place_of_birth }}, {{ detailDriver.driver_date_of_birth | tanggal }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Alamat</div>
							<div class="">{{ detailDriver.driver_address }}</div>
						</v-col>

						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Nomor Hp</div>
							<div class="">{{ detailDriver.driver_mobilephone }}</div>
						</v-col>
						<v-col cols="6" md="4">
							<div class="grey--text text--darken-2">Email</div>
							<div class="">{{ detailDriver.driver_email }}</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="modalHide">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';

export default {
	data () {
		return {
			dialog: false
		}
	},
	computed:{
		...mapState('driver', ['detailDriver']),

	},
	props: {
		
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		formatDateText(params, format) {
			let dates = (params) ? new Date(params) : null
			return (dates) ? moment(dates).format(format) : null
		},
	}
};
</script>